'use strict';

module.exports = {
  highlightRange: () => {
    // eslint-disable-next-line no-console
    console.log('highlightRange not implemented');
  },

  removeHighlights: () => {
    // eslint-disable-next-line no-console
    console.log('removeHighlights not implemented');
  },

  getBoundingClientRect: () => {
    // eslint-disable-next-line no-console
    console.log('getBoundingClientRect not implemented');
  },
};
